"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientCredentialsAuthProvider = void 0;
const tslib_1 = require("tslib");
const shared_utils_1 = require("@d-fischer/shared-utils");
const common_1 = require("@twurple/common");
const AccessToken_1 = require("../AccessToken");
const helpers_1 = require("../helpers");
/**
 * An auth provider that retrieve tokens using client credentials.
 */
let ClientCredentialsAuthProvider = class ClientCredentialsAuthProvider {
    /**
     * Creates a new auth provider to receive an application token with using the client ID and secret.
     *
     * @param clientId The client ID of your application.
     * @param clientSecret The client secret of your application.
     */
    constructor(clientId, clientSecret) {
        /**
         * The type of tokens the provider generates.
         *
         * This auth provider generates app tokens.
         */
        this.tokenType = 'app';
        this._clientId = clientId;
        this._clientSecret = clientSecret;
    }
    /**
     * Retrieves an access token.
     *
     * If any scopes are provided, this throws. The client credentials flow does not support scopes.
     *
     * @param scopes The requested scopes.
     */
    async getAccessToken(scopes) {
        if (scopes && scopes.length > 0) {
            throw new Error(`Scope ${scopes.join(', ')} requested but the client credentials flow does not support scopes`);
        }
        if (!this._token || AccessToken_1.accessTokenIsExpired(this._token)) {
            return await this.refresh();
        }
        return this._token;
    }
    /**
     * Retrieves a new app access token.
     */
    async refresh() {
        return (this._token = await helpers_1.getAppToken(this._clientId, this._clientSecret));
    }
    /**
     * The client ID.
     */
    get clientId() {
        return this._clientId;
    }
    /**
     * The scopes that are currently available using the access token.
     */
    get currentScopes() {
        return [];
    }
};
tslib_1.__decorate([
    shared_utils_1.Enumerable(false)
], ClientCredentialsAuthProvider.prototype, "_clientSecret", void 0);
tslib_1.__decorate([
    shared_utils_1.Enumerable(false)
], ClientCredentialsAuthProvider.prototype, "_token", void 0);
ClientCredentialsAuthProvider = tslib_1.__decorate([
    common_1.rtfm('auth', 'ClientCredentialsAuthProvider', 'clientId')
], ClientCredentialsAuthProvider);
exports.ClientCredentialsAuthProvider = ClientCredentialsAuthProvider;
